export default [
  {
    label: 'BACS',
    value: 'BACS',
  },
  {
    label: 'Cheque',
    value: 'cheque',
  },
  {
    label: 'Card',
    value: 'card',
  },
];
